import { cn } from "@/lib/utils";
import { Input } from "@/components/ui/input";

function daysAgo(n) {
  const d = new Date();
  d.setDate(d.getDate() - n);
  return d.toISOString().slice(0, 10);
}

const presets = [
  { key: "7d", label: "7D", start: () => daysAgo(6) },
  { key: "30d", label: "30D", start: () => daysAgo(29) },
  { key: "90d", label: "90D", start: () => daysAgo(89) },
  { key: "all", label: "All", start: () => "" },
];

export default function DateRange({ range, setRange }) {
  const applyPreset = (p) =>
    setRange({ start: p.start(), end: "", preset: p.key });

  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="date-range">
      <div className="flex gap-1 bg-secondary/60 rounded-full p-1">
        {presets.map((p) => (
          <button
            key={p.key}
            onClick={() => applyPreset(p)}
            data-testid={`range-${p.key}`}
            className={cn(
              "px-3.5 py-1.5 rounded-full text-xs font-semibold transition-colors",
              range.preset === p.key
                ? "bg-card shadow-sm text-foreground"
                : "text-muted-foreground hover:text-foreground"
            )}
          >
            {p.label}
          </button>
        ))}
      </div>
      <div className="flex items-center gap-1.5">
        <Input
          type="date"
          value={range.start || ""}
          onChange={(e) => setRange({ ...range, start: e.target.value, preset: "custom" })}
          data-testid="range-start"
          className="rounded-full h-9 w-[9.5rem] text-xs"
        />
        <span className="text-muted-foreground text-xs">→</span>
        <Input
          type="date"
          value={range.end || ""}
          onChange={(e) => setRange({ ...range, end: e.target.value, preset: "custom" })}
          data-testid="range-end"
          className="rounded-full h-9 w-[9.5rem] text-xs"
        />
      </div>
    </div>
  );
}
